import React from "react";

export default function HeroSection() {
  return (
    <>
      <h1>
        <span>Willkommen... </span> <br />
        <span>This is Olaolu Ajibade</span>
      </h1>
      <p className="herotext">
        Software Developer and Freelancer
        <br />Writing, Open Source Contributor, Clean-Codes, Testing and lots more...
      </p>
    </>
  );
}
